import redirectPermanently from '@/components/Redirect/redirectPermanently';

const ValidateScrumCertificate = () =>
  redirectPermanently('/validar-certificacion');

export default ValidateScrumCertificate;
